// Hamburger menu
let hamburger = document.querySelector('.hamburger');
let menu = document.querySelector('.list__btn');

function showMenu () {
  hamburger.classList.toggle('hamburger__active');
  menu.classList.toggle('list__btn--active');
}

// Copyright
let copyrightDate = new Date();
document.querySelector('.footer__copyright p span').textContent = copyrightDate.getFullYear();

// WOW Animation
let wow = new WOW(
    {
      boxClass:     'wow',
      animateClass: 'animate__animated',
      mobile: false
    }
);
wow.init();

if (window.innerWidth < 1025) {
  $videoBg = document.querySelector('.main_screen__video_bg');
  if ($videoBg) {
    $videoBg.remove();
  }
}
//Плавная прокрутка до якоря
document.querySelectorAll('a[href^="#"]:not([href="#"])').forEach(link => {
    link.addEventListener('click', function (e) {
        e.preventDefault();

        const target = document.querySelector(this.getAttribute('href'));

        if (target) {
            const headerHeight = 88;
            const targetPosition =
                target.getBoundingClientRect().top +
                window.scrollY -
                headerHeight;

            window.scrollTo({
                top: targetPosition,
                behavior: 'smooth'
            });
        }
    });
});

// Video youtube
function r(f) {
    /in/.test(document.readyState) ? setTimeout(() => r(f), 9) : f();
}

r(function () {
    var videos;

    if (!document.getElementsByClassName) {
        // IE8 fallback
        var getElementsByClassName = function (node, classname) {
            var a = [];
            var re = new RegExp('(^| )' + classname + '( |$)');
            var els = node.getElementsByTagName("*");
            for (var i = 0; i < els.length; i++) {
                if (re.test(els[i].className)) a.push(els[i]);
            }
            return a;
        };
        videos = getElementsByClassName(document.body, "youtube");
    } else {
        videos = document.getElementsByClassName("youtube");
    }

    for (var i = 0; i < videos.length; i++) {
        var video = videos[i];

        // Постер YouTube
        video.style.backgroundImage =
            'url(https://img.youtube.com/vi/' + video.id + '/maxresdefault.jpg)';

        // 👉 Создаём кнопку Play для КАЖДОГО видео
        var play = document.createElement('div');
        play.className = 'video-contest__video--play';
        video.appendChild(play);

        video.onclick = function () {
            document.querySelectorAll('iframe.youtube').forEach((player) => {
                player.src = player.src.replace('autoplay=1', 'autoplay=0');
            });

            var iframe = document.createElement("iframe");
            var iframe_url =
                "https://www.youtube.com/embed/" +
                this.id +
                "?autoplay=1&autohide=1";

            if (this.getAttribute("data-params")) {
                iframe_url += '&' + this.getAttribute("data-params");
            }

            iframe.setAttribute("src", iframe_url);
            iframe.setAttribute("class", 'youtube');
            iframe.setAttribute("frameborder", '0');
            iframe.setAttribute("allowfullscreen", '');
            iframe.setAttribute(
                "allow",
                'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
            );

            this.parentNode.replaceChild(iframe, this);
        };
    }
});
